<template>
  <CRow class="main py-5">
    <CCol sm="9" class="py-2">
      <CRow class="">
        <CCol class="h-100">
          <h4 class="">
            {{ $t('settings.security.component.password.title') }}
          </h4>
          <div class="border-line"></div>
        </CCol>
      </CRow>

      <CRow class="mt-2">
        <CCol sm="7">
          <CForm autocomplete="off">
            <CInput
              class="mb-0"
              :label="$t('settings.security.component.inputLabel.current')"
              :type="typeOldPassword"
              addLabelClasses="mt-1 required"
              :value.sync="$v.password.currentPassword.$model"
              :invalidFeedback="'preenchimento obrigatório!'"
              :isValid="checkIfValid('currentPassword')"
              id="currentPassword"
              placeholder=""
              autocomplete="off"
            >
              <template #append>
                <CButton @click="showPassword('typeOldPassword', typeOldPassword)">
                  <i class="far" :class="getPasswordIcon(typeOldPassword)"></i>
                </CButton>
              </template>
            </CInput>
          </CForm>
        </CCol>
      </CRow>

      <CForm autocomplete="OFF">
        <CRow class="mt-2">
          <CCol sm="7">
            <CInput
              class="mb-0"
              :label="$t('settings.security.component.inputLabel.new')"
              :type="typeInputPassword"
              addLabelClasses="mt-1 required"
              :value.sync="$v.password.newPassword.$model"
              :invalidFeedback="$t('settings.security.component.password.invalidFeedback')"
              placeholder=""
              id="newPassword"
              :isValid="checkIfValid('newPassword')"
              v-focus="focused"
              @focus="focused = true"
              @blur="focused = false"
            >
              <template #append>
                <CButton @click="showPassword('typeInputPassword', typeInputPassword)">
                  <i class="far" :class="getPasswordIcon(typeInputPassword)"></i>
                </CButton>
              </template>
            </CInput>

            <div v-show="focused" class="text-muted checkPassword">
              <p class="text-muted mb-1">{{ this.$t('settings.security.component.password.password-must-have') }}:</p>
              <ul class="p-0 font-smaller checkPassword__list">
                <li v-for="(item, i) in listCheckPassword" :key="i" class="font-smaller checkPassword__item" :class="{ 'is-valid': item.isValid }">
                  * {{ item.name }}
                </li>
              </ul>
            </div>
          </CCol>
        </CRow>

        <CRow class="mt-2">
          <CCol sm="7">
            <CInput
              class="mb-0"
              label="Confirm Password"
              :type="typeConfirmPassword"
              addLabelClasses="mt-1 required"
              :value.sync="$v.password.ConfirmPassword.$model"
              id="ConfirmPassword"
              :invalidFeedback="$t('settings.security.component.password.invalidFeedback-password-match')"
              :isValid="checkIfValid('ConfirmPassword')"
              placeholder=""
              autocomplete="false"
            >
              <template #append>
                <CButton @click="showPassword('typeConfirmPassword', typeConfirmPassword)">
                  <i class="far" :class="getPasswordIcon(typeConfirmPassword)"></i>
                </CButton>
              </template>
            </CInput>
          </CCol>
        </CRow>

        <CRow class="mt-4">
          <CCol sm="6">
            <CButton :disabled="disableButtons" color="gray-500" type="button" class="py-2 px-5" @click="cancelForm()">
              {{ $t('settings.security.component.password.button.cancel') }}
            </CButton>

            <CButton :disabled="disableButtons" color="primary" class="py-2 px-5 ml-4" @click="submitPassword()">
              {{ $t('settings.security.component.password.button.confirm') }}
            </CButton>
          </CCol>
        </CRow>
      </CForm>
    </CCol>
  </CRow>
</template>

<script>
import { required, sameAs } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import services from '@/services.js'

export default {
  name: 'Password',
  mixins: [validationMixin],
  data() {
    return {
      password: {
        currentPassword: '',
        newPassword: '',
        ConfirmPassword: '',
      },
      typeOldPassword: 'password',
      typeInputPassword: 'password',
      typeConfirmPassword: 'password',
      messages: [],
      focused: false,
      disableButtons: false,
      listCheckPassword: {
        hasLowerCase: { name: this.$t('auth.newRegister.text.lower-case'), isValid: false },
        hasSpecial: { name: this.$t('auth.newRegister.text.especial-character'), isValid: false },
        hasUppercase: {
          name: this.$t('auth.newRegister.text.uppercase-character'),
          isValid: false,
        },
        hasMinNumber: { name: this.$t('auth.newRegister.text.minimal-character'), isValid: false },
        hasNumber: { name: this.$t('auth.newRegister.text.one-number'), isValid: false },
      },
    }
  },

  mounted() {},

  methods: {
    showPassword(prop, type) {
      this[prop] = type == 'password' ? 'text' : 'password'
    },

    getPasswordIcon(type) {
      return type == 'password' ? `fa-eye` : `fa-eye-slash`
    },

    checkIfValid(fieldName) {
      const field = this.$v.password[fieldName]
      if (!field.$dirty) {
        return null
      }
      return !(field.$invalid || null)
    },

    cancelForm() {
      this.password.currentPassword = ''
      this.password.newPassword = ''
      this.password.ConfirmPassword = ''
      this.$v.$reset()
    },

    submitPassword() {
      this.$v.password.$touch()
      if (this.$v.password.$invalid) {
        return
      }

      this.messages = []
      this.password.email = this.$store.state.auth.user.email
      this.disableButtons = true
      services
        .updatePassword(this.password)
        .then(() => {
          this.messages.push({
            status: 'success',
            text: this.$t('settings.security.component.password.updated-text'),
          })

          this.$emit('passwordChanged', {
            status: 'success',
            text: this.$t('settings.security.component.password.updated-text'),
          })
        })
        .catch(({ response }) => {
          this.$emit('passwordChanged', {
            status: 'danger',
            text: response.data.message,
          })
        })
        .finally(() => {
          this.disableButtons = false
          this.cancelForm()
        })
    },
  },

  validations: {
    password: {
      currentPassword: {
        required,
      },
      newPassword: {
        required,
        strongPassword(password) {
          return (
            /[a-z]/.test(password) && // checks for a-z
            /[A-Z]/.test(password) && // checks for A-Z
            /[0-9]/.test(password) && // checks for 0-9
            /\W|_/.test(password) && // checks for special char
            password.length >= 8
          )
        },
      },
      ConfirmPassword: {
        sameAs: sameAs('newPassword'),
      },
    },
  },

  watch: {
    'password.newPassword': {
      deep: true,
      handler() {
        this.listCheckPassword.hasLowerCase.isValid = /[a-z]/.test(this.password.newPassword) ? true : null
        this.listCheckPassword.hasUppercase.isValid = /[A-Z]/.test(this.password.newPassword) ? true : null
        this.listCheckPassword.hasNumber.isValid = /[0-9]/.test(this.password.newPassword) ? true : null
        this.listCheckPassword.hasSpecial.isValid = /\W|_/.test(this.password.newPassword) ? true : null
        this.listCheckPassword.hasMinNumber.isValid = this.password.newPassword.length >= 8 ? true : null
      },
    },
  },
  computed: {
    isValid() {
      return !this.$v.$invalid
    },

    iconInputPassword() {
      return this.typeInputPassword === 'password' ? 'eye-slash' : 'eye'
    },
  },
}
</script>

<style scoped>
.border-line {
  border-bottom: 2px solid #d1d4da;
}
</style>
